/** Optional free-text notes from the Personalization step. */
export const PERSONALIZATION_NOTES_CONFIGURATION_KEY = 'personalizationNotes';

export const PERSONALIZATION_NOTES_LABEL = 'Uwagi do personalizacji';

export const normalizePersonalizationNotes = (
	value: string | number | null | undefined
): string => {
	if (value === null || value === undefined) return '';
	return String(value);
};
